import { render, staticRenderFns } from "./ExtraMealOrderItem.vue?vue&type=template&id=29957b02&scoped=true&"
import script from "./ExtraMealOrderItem.vue?vue&type=script&lang=ts&"
export * from "./ExtraMealOrderItem.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraMealOrderItem.vue?vue&type=style&index=0&id=29957b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29957b02",
  null
  
)

export default component.exports